export const LOAD_CONFIGURATION = 'LOAD_CONFIGURATION'
export const loadConfiguration = (configuration) => ({ type: LOAD_CONFIGURATION, configuration})
